<template>
    <div>
        <p class="title">申请人信息</p>
        <van-cell-group>
            <van-field required readonly label="姓名" v-model="userInfo.xm" readonly input-align="right"/>
            <van-field required readonly clickable label="性别" v-model="userInfo.xbmc" placeholder="请选择"
                       @click="showPickerSex = true" input-align="right" is-link/>
            <van-popup v-model="showPickerSex" position="bottom">
                <van-picker show-toolbar :columns="sexList" value-key="name" @cancel="showPickerSex = false"
                            @confirm="onConfirmSex"/>
            </van-popup>
            <van-field required readonly clickable label="出生日期" v-model="userInfo.csrq" placeholder="请选择"
                       @click="showPickerBirthDate = true" input-align="right" is-link/>
            <van-popup v-model="showPickerBirthDate" position="bottom">
                <van-datetime-picker v-model="currentDate" type="date" :max-date="maxDate" :min-date="minDate"
                                     @cancel="showPickerBirthDate = false" @confirm="onConfirmBirthdayDate"/>
            </van-popup>
            <van-field required v-model="userInfo.gmsfhm" clearable readonly label="公民身份证号" placeholder="请输入身份证号"
                       input-align="right"/>
            <!--户籍地址-->
            <van-field v-model="userInfo.hjdz1" label="户籍地址:" placeholder="请选择省份" is-link required readonly
                       input-align="right"
                       @click="showPickerHJProvince = true"/>
            <van-popup v-model="showPickerHJProvince" position="bottom">
                <van-picker :columns="provinceList" show-toolbar value-key="title"
                            @cancel="showPickerHJProvince = false"
                            @confirm="onConfirmHJProvince"/>
            </van-popup>
            <van-field v-model="userInfo.hjdz2" placeholder="请选择市区" is-link readonly input-align="right"
                       @click="showPickerHJCity = true" v-if="HJCityShow"/>
            <van-popup v-model="showPickerHJCity" position="bottom">
                <van-picker :columns="cityHJList" show-toolbar value-key="title" @cancel="showPickerHJCity = false"
                            @confirm="onConfirmHJCity"/>
            </van-popup>
            <van-field v-model="userInfo.hjdz3" placeholder="请选择区县" is-link readonly input-align="right"
                       @click="showPickerHJArea = true" v-if="HJAreaShow"/>
            <van-popup v-model="showPickerHJArea" position="bottom">
                <van-picker :columns="areaHJList" show-toolbar value-key="title" @cancel="showPickerHJArea = false"
                            @confirm="onConfirmHJArea"/>
            </van-popup>
            <van-field input-align="right" type="textarea" v-model="userInfo.hjdzxxdz"
                       placeholder="请输入区划内详细地址" rows="1" autosize clearable/>
            <van-field input-align="right" label="所属派出所:" type="textarea" required v-model="userInfo.hjsspcs"
                       placeholder="请输入原户籍地派出所" rows="1" autosize clearable/>
            <!--拟落户地址-->
            <van-field v-model="userInfo.nlhdzlx" label="拟落户类型:" placeholder="请选择" is-link required readonly
                       input-align="right" @click="showPickernlhdlx = true"/>
            <van-popup v-model="showPickernlhdlx" position="bottom">
                <van-picker :columns="nlhlxList" show-toolbar value-key="title"
                            @cancel="showPickernlhdlx = false" @confirm="onConfirmLH"/>
            </van-popup>
            <van-field v-model="userInfo.nlhdz1" label="拟落户地址:" placeholder="请选择省份" is-link required readonly
                       input-align="right"
                       @click="showPickerLHProvince = true"/>
            <van-popup v-model="showPickerLHProvince" position="bottom">
                <van-picker :columns="provinceLHList" show-toolbar value-key="title"
                            @cancel="showPickerLHProvince = false"
                            @confirm="onConfirmLHProvince"/>
            </van-popup>
            <van-field v-model="userInfo.nlhdz2" placeholder="请选择市区" is-link readonly input-align="right"
                       @click="showPickerLHCity = true" v-if="LHCityShow"/>
            <van-popup v-model="showPickerLHCity" position="bottom">
                <van-picker :columns="cityLHList" show-toolbar value-key="title" @cancel="showPickerLHCity = false"
                            @confirm="onConfirmLHCity"/>
            </van-popup>
            <van-field v-model="userInfo.nlhdz3" placeholder="请选择区县" is-link readonly input-align="right"
                       @click="showPickerLHArea = true" v-if="LHAreaShow"/>
            <van-popup v-model="showPickerLHArea" position="bottom">
                <van-picker :columns="areaLHList" show-toolbar value-key="title" @cancel="showPickerLHArea = false"
                            @confirm="onConfirmLHArea"/>
            </van-popup>
            <van-field input-align="right" type="textarea" v-model="userInfo.nlhdzxxdz"
                       placeholder="请输入区划内详细地址" rows="1" autosize clearable/>
            <van-field required label="联系电话" v-model="userInfo.lxfs" input-align="right" clearable/>
        </van-cell-group>
    </div>
</template>

<script>
  import { Button, Toast, CellGroup, Field, Dialog, Popup, Picker, DatetimePicker, RadioGroup, Radio } from 'vant'
  import { dateToString } from '@/utils/time'
  import { baseApiMap } from '@/api/base'
  import { idCardRegex, phoneRegex } from '@/utils/regex'
  import {forEachObj} from '@/utils/check'

  export default {
    components: {
      [Button.name]: Button,
      [Toast.name]: Toast,
      [CellGroup.name]: CellGroup,
      [Field.name]: Field,
      [Dialog.name]: Dialog,
      [Popup.name]: Popup,
      [Picker.name]: Picker,
      [DatetimePicker.name]: DatetimePicker,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio
    },
    props: {
      applicationInfo: {
        type: Object,
        default: () => ({})
      },
      matNum: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        userInfo: {
          xm: this.$cookie.getUser().realName,
          xb: '',
          csrq: '',
          gmsfhm: this.$cookie.getUser().idNum.replace(/^(\d{3})\d{10}(\d+)/, '$1**********$2'),
          hjdz3: '',
          hjdzxxdz: '',
          hjsspcs: '',
          nlhdzlx: '',
          nlhdz3: '',
          nlhdzxxdz: '',
          lxfs: this.$cookie.getUser().telephone
        },
        sexList: [],
        showPickerSex: false, // 是否显示性别选择框
        currentDate: new Date(), // 当前日期
        minDate: new Date(1900, 0, 1), // 最小日期
        maxDate: new Date(), //最大日期
        showPickerBirthDate: false, // 是否显示出生日期选择框
        provinceLHList: [{ "title": '湖北省', "val": '420000' }], // 省
        provinceList: [], // 省
        cityHJList: [], // 户籍市
        areaHJList: [], // 户籍区县
        showPickerHJProvince: false, // 是否显示户籍省选择框
        HJCityShow: false, // 是否显示户籍市
        HJAreaShow: false, // 是否显示户籍区县
        showPickerHJCity: false, // 是否显示户籍市选择框
        showPickerHJArea: false, // 是否显示户籍区县选择框
        showPickernlhdlx: false, // 是否显示拟落户地址类型选择框
        nlhlxList: [{ val: '家庭户', title: '家庭户' }, { val: '单位集体户', title: '单位集体户' },
          { val: '社区公共户', title: '社区公共户' }], // 拟落户地址类型
        cityLHList: [], // 拟落户地址市
        areaLHList: [], // 拟落户地址区县
        showPickerLHProvince: false, // 是否显示拟落户地址省选择框
        LHCityShow: false, // 是否显示拟落户地址市
        LHAreaShow: false, // 是否显示拟落户地址区县
        showPickerLHCity: false, // 是否显示拟落户地址市选择框
        showPickerLHArea: false, // 是否显示拟落户地址区县选择框

      }
    },
    mounted() {
      this.getProvinceData()
      this.getSexList()
    },
    methods: {
      /**
       * 加载性别
       */
      getSexList() {
        this.$httpUtils.getCommonUtils(`${baseApiMap.dict}/dic.hz.xblb`).then(response => {
          let arr = [];
          if (response.data.succ = true) {
            let arrSex = response.data.data;
            for (let i = 0; i < arrSex.length; i++) {
              arr.push({ "name": arrSex[i].title, "key": arrSex[i].val })
            }
          }
          this.$nextTick(() => {
            this.sexList = arr
          })
        }).catch(err => {

        })
      },
      /**
       * 获取省
       */
      async getProvinceData() {
        try {
          const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + 0)
          let arr = [];
          if (res.data.succ = true) {
            let d = res.data.data
            for (let i = 0; i < d.length; i++) {
              arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
            }
          }
          this.provinceList = arr
        } catch (error) {
          Toast('服务器运行失败')
          console.log(error);
        }
      },
      /**
       * 获取市
       */
      async getHJCityData(value) {
        try {
          this.cityHJList = []
          this.areaHJList = []
          const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
          let arr = [];
          if (res.data.succ = true) {
            let d = res.data.data
            for (let i = 0; i < d.length; i++) {
              arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
            }
          }
          this.cityHJList = arr
          if (this.cityHJList.length > 0) {
            this.HJCityShow = true
          } else {
            this.HJCityShow = false
          }
        } catch (error) {
          Toast('服务器运行失败');
          console.log(error);
        }
      },
      /**
       * 获取地区
       */
      async getHJAreaData(value) {
        try {
          this.areaHJList = []
          const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
          let arr = [];
          if (res.data.succ = true) {
            let d = res.data.data
            for (let i = 0; i < d.length; i++) {
              arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
            }
          }
          this.areaHJList = arr
          if (this.areaHJList.length > 0) {
            this.HJAreaShow = true
          } else {
            this.HJAreaShow = false
          }
        } catch (error) {
          Toast('服务器运行失败');
          console.log(error);
        }
      },
      /**
       * 选择性别
       */
      onConfirmSex(value) {
        this.userInfo.xbmc = value.name
        this.userInfo.xb = value.key
        this.showPickerSex = false
      },
      /**
       * 选择出生日期
       */
      onConfirmBirthdayDate(value) {
        this.userInfo.csrq = dateToString(value, "yyyy-MM-dd")
        this.showPickerBirthDate = false
      },
      /**
       * 选择户籍地址省
       */
      onConfirmHJProvince(value) {
        this.userInfo.hjdz1 = value.title
        this.userInfo.hjdz2 = ''
        this.userInfo.hjdz3 = ''
        this.showPickerHJProvince = false
        this.getHJCityData(value.val)
      },
      /**
       * 选择户籍地址市
       */
      onConfirmHJCity(value) {
        this.showPickerHJCity = false
        this.userInfo.hjdz2 = value.title
        this.userInfo.hjdz3 = ''
        this.getHJAreaData(value.val)
      },
      /**
       * 选择户籍区县
       */
      onConfirmHJArea(value) {
        this.showPickerHJArea = false
        this.userInfo.hjdz3 = value.title
      },
      /**
       * 选择拟落户地址类型
       */
      onConfirmLH(value) {
        this.showPickernlhdlx = false
        this.userInfo.nlhdzlx = value.title
      },
      /**
       * 获取拟落户地址市
       */
      async getLHCityData(value) {
        try {
          this.cityLHList = []
          this.areaLHList = []
          if (this.matNum === 'hj0047' || this.matNum === 'hj0048') {
            this.cityLHList = [{ val: "420100", title: "武汉市" }]
          } else {
            const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
            let arr = [];
            if (res.data.succ = true) {
              let d = res.data.data
              for (let i = 0; i < d.length; i++) {
                arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
              }
            }
            this.cityLHList = arr
          }

          if (this.cityLHList.length > 0) {
            this.LHCityShow = true
          } else {
            this.LHCityShow = false
          }
        } catch (error) {
          Toast('服务器运行失败');
          console.log(error);
        }
      },
      /**
       * 获取拟落户地址区县
       */
      async getLHAreaData(value) {
        try {
          this.areaLHList = []
          const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
          let arr = [];
          if (res.data.succ = true) {
            let d = res.data.data
            for (let i = 0; i < d.length; i++) {
              arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
            }
          }
          this.areaLHList = arr
          if (this.areaLHList.length > 0) {
            this.LHAreaShow = true
          } else {
            this.LHAreaShow = false
          }
        } catch (error) {
          Toast('服务器运行失败');
          console.log(error);
        }
      },
      /**
       * 选择拟落户地址省
       */
      onConfirmLHProvince(value) {
        this.userInfo.nlhdz1 = value.title
        this.userInfo.nlhdz2 = ''
        this.userInfo.nlhdz3 = ''
        this.showPickerLHProvince = false
        this.getLHCityData(value.val)
      },
      /**
       * 选择拟落户地址市
       */
      onConfirmLHCity(value) {
        this.showPickerLHCity = false
        this.userInfo.nlhdz2 = value.title
        this.userInfo.nlhdz3 = ''
        this.getLHAreaData(value.val)
      },
      /**
       * 选择拟落户地址区县
       */
      onConfirmLHArea(value) {
        this.showPickerLHArea = false
        this.userInfo.nlhdz3 = value.title
      },
      /**
       * 校验数据
       */
      validApplicationPersonInfo2() {
          forEachObj(this.userInfo) // 去掉空格
        if (!this.userInfo.xm) {
          Toast('请输入申请人姓名')
          this.$emit('getApplicationPersonInfo2', false)
          return
        }
        if (!this.userInfo.xb) {
          Toast('请选择性别')
          this.$emit('getApplicationPersonInfo2', false)
          return
        }
        if (!this.userInfo.csrq) {
          Toast('请选择出生日期')
          this.$emit('getApplicationPersonInfo2', false)
          return
        }
        if (!this.userInfo.gmsfhm) {
          Toast('请输入公民身份证号')
          this.$emit('getApplicationPersonInfo2', false)
          return
        }
        if (!this.userInfo.hjdz3) {
          Toast('请选择户籍地址')
          this.$emit('getApplicationPersonInfo2', false)
          return
        }
        if (!this.userInfo.hjdzxxdz) {
          Toast('请输入户籍区划内详细地址')
          this.$emit('getApplicationPersonInfo2', false)
          return
        }
        if (!this.userInfo.hjsspcs) {
          Toast('请输入户籍派出所')
          this.$emit('getApplicationPersonInfo2', false)
          return
        }
        if (!this.userInfo.nlhdzlx) {
          Toast('请选择拟落户类型')
          this.$emit('getApplicationPersonInfo2', false)
          return
        }
        if (!this.userInfo.nlhdz3) {
          Toast('请选择拟落户地址')
          this.$emit('getApplicationPersonInfo2', false)
          return
        }
        if (!this.userInfo.nlhdzxxdz) {
          Toast('请输入拟落户详细地址')
          this.$emit('getApplicationPersonInfo2', false)
          return
        }
        if (!this.userInfo.lxfs) {
          Toast('请输入联系电话')
          this.$emit('getApplicationPersonInfo2', false)
          return
        }
        if (!phoneRegex(this.userInfo.lxfs)) {
          Toast('联系电话不正确')
          this.$emit('getApplicationPersonInfo2', false)
          return
        }

        this.applicationInfo.xm = this.userInfo.xm
        this.applicationInfo.xb = this.userInfo.xb
        this.applicationInfo.csrq = this.userInfo.csrq
        this.applicationInfo.gmsfhm = this.$cookie.getUser().idNum
        this.applicationInfo.lxdh = this.userInfo.lxfs
        this.applicationInfo.hjdz = this.userInfo.hjdz1 + this.userInfo.hjdz2 + this.userInfo.hjdz3 + this.userInfo.hjdzxxdz
        this.applicationInfo.sspcs = this.userInfo.hjsspcs
        this.applicationInfo.nlhdzlx = this.userInfo.nlhdzlx
        this.applicationInfo.nlhdz = this.userInfo.nlhdz1 + this.userInfo.nlhdz2 + this.userInfo.nlhdz3 + this.userInfo.nlhdzxxdz


        this.$emit('getApplicationPersonInfo2', true)
        return
      }
    }
  }
</script>

<style lang="less" scoped>
    .title {
        padding: 0.3rem;
        color: #808080;
    }
</style>
